import { PageTitle } from "@/components/pageTitle";

export const PainPoints = () => {
  return (
    <div className="flex justify-center">
      <div className="pt-[101px] px-[157px] w-[1920px]">
        <PageTitle title="企业出海直播遇到的问题" />
        <img
          src="/imgs/saas/pain.png"
          alt="pain-points"
          className="mt-[80px]"
        />
      </div>
    </div>
  );
};
